<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader page-name="Images" />
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <div class="row">
              <div class="col-lg-12 add-form mb-4 d-flex justify-content-end">
                <router-link :to="{ name: 'AddImage', params: {parent_id: this.productId}}">
                  <button class="btn btn-info">Add New Image</button>
                </router-link>
              </div>
            </div>
            <section v-if="!isLoading">
              <datatable :fields="fields" :items="items"/>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Pageheader from '@/components/Pageheader.vue'
import Datatable from '@/components/Datatable.vue'
export default {
  name: 'Images',
  data () {
    return {
      API_BASE_URL: 'image',
      items: []
    }
  },
  computed: {
    isLoading () {
      if (this.items.length === 0) {
        return this.$store.getters[this.API_BASE_URL + '/apiLoading']
      } else { return false }
    },
    productId () {
      return this.$route.params.id
    },
    fields () {
      return [
        { label: 'Name', key: 'name' },
        { label: 'Image #', key: 'image_no' },
        { label: 'Product', key: 'productName' },
        { label: 'Enabled', key: 'is_enabled' },
        { label: 'Sort #', key: 'sort_no' },
        {
          label: 'Action',
          key: 'action',
          actions: {
            edit: {
              name: 'EditImage',
              params: { parent_id: this.productId }
            },
            remove: (id) => this.remove(id)
          }
        }
      ]
    }
  },
  mounted () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.items = []
      this.$store.dispatch('product/images', {id: this.productId})
        .then((result) => {
          result.images.forEach(item => {
            this.items.push(item)
          })
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    remove (id) {
      this.$confirm({
        message: `Are you sure you want to delete this image?`,
        button: { no: 'No', yes: 'Yes' },
        callback: confirm => {
          if (confirm) {
            this.$store.dispatch(this.API_BASE_URL + '/delete', id)
              .then((result) => {
                this.$toast.success(result.data.message)
                this.fetchAll()
              })
              .catch((err) => this.$toast.error(err.response.data.message))
          }
        }
      })
    }
  },
  components: { Pageheader, Datatable }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Products/Images/index.vue